import { COMMON_META, TRUST_INTERSTITIAL } from './shared';

// Lab analysis — general-wellness labs + provider feedback — /lab-analysis.
const stages = ['Start', 'Health', 'Goals', 'Results', 'Eligibility'];

const meta = {
  ...COMMON_META('Health'),
  'basic-contact': { stage: 'Start', headline: ['Your labs, explained', 'by a real provider.'], image: 'labs/report' },
  'sex-at-birth': { stage: 'Health', headline: ['Care can be tailored to', 'your unique needs.'], hint: 'Some reference ranges differ by sex.', image: 'common/profile', optionIcons: { male: '👨', female: '👩' } },
  'height-weight': { stage: 'Health', headline: ["Let's find", 'your baseline.'], image: 'common/measure' },
  'wellness-consent': { stage: 'Health', headline: ['The fine print,', 'made clear.'], image: 'common/consent' },
  'lab-goals': { stage: 'Goals', headline: ['What do you want', 'to learn?'], hint: 'Select all that apply.', image: 'labs/goals' },
  'lab-goals-other': { stage: 'Goals', headline: ['Tell us more about', 'your goal.'], image: 'labs/goals' },
  lifestyle: { stage: 'Goals', headline: ['Context makes', 'numbers meaningful.'], hint: 'Select all that apply.', image: 'glp1/activity' },
  'last-lab-date': { stage: 'Results', headline: ['When were you', 'last tested?'], image: 'common/calendar' },
  'abnormal-results': { stage: 'Results', headline: ['Anything flagged', 'before?'], image: 'labs/report' },
  'abnormal-describe': { stage: 'Results', headline: ['Tell us what', 'was flagged.'], image: 'labs/report' },
  'lab-results': { stage: 'Results', headline: ['Share your', 'results.'], hint: 'Upload a report or enter values — your provider reviews either.', image: 'labs/report' },
  'shipping-address': { stage: 'Details', headline: ['Where are you', 'based?'], image: 'common/shipping' },
  'ix-trust': { stage: 'Start' }, 'ix-what': { stage: 'Goals' },
};

const interstitials = [
  TRUST_INTERSTITIAL('ix-trust', 'allergies', { plain: 'Stop guessing what', accent: 'your labs mean.', banner: 'Lab analysis & provider feedback', rank: '1:1', title: 'provider review of your results', bullets: ['Upload results from any lab', 'A licensed U.S. provider reviews them within 24 hours', 'Plain-English feedback and next steps in your dashboard', 'No prescription required to get started'] }),
  {
    id: 'ix-what', after: 'lab-goals', kind: 'curve', plain: 'What happens', accent: 'after you submit?',
    yLabel: ['Clarity about', 'your health'], arrowLabel: ['Action', 'plan'], xLabels: ['Today', 'Day 1', 'Day 2', 'Day 3+'],
    bullets: ['– Today: share your results and goals', '– Day 1: a licensed provider reviews every marker', ['– Day 2+: personalized feedback and ', 'recommended next steps']],
  },
];

const labAnalysis = {
  key: 'labAnalysis', route: '/lab-analysis', title: 'Lab Analysis', stages, fallbackStage: 'Health',
  stageDefaults: {
    Start: { headline: ['Your labs, explained', 'by a real provider.'], image: 'labs/report' },
    Health: { headline: ['Your health history', 'gives your labs context.'], image: 'common/health' },
    Goals: { headline: ['What do you want', 'to learn?'], image: 'labs/goals' },
    Results: { headline: ['Share your', 'results.'], image: 'labs/report' },
    Details: { headline: ['Almost there —', 'a few final details.'], image: 'common/consent' },
    Eligibility: { headline: ['Ready when', 'you are.'], image: null },
  },
  meta, interstitials,
};
export default labAnalysis;
